import { Box } from '@mui/material';
import { BracketSeedMatchGameEntity, TournamentTeamEntity } from 'app/interfaces/entity';
import { isArray } from 'lodash';
import { currentTournamentSelector } from 'modules/tournaments/store/current-tournament/selectors';
import { useSelector } from 'react-redux';
import { EmptyPlaceholder } from 'shared/components/EmptyPlaceholder';
import { TournamentMatchGameCard } from '../TournamentMatchGameCard';
import React, { FC } from 'react';
import { useStyles } from './TournamentMatchGamesList.styles';

interface TournamentMatchGamesListProps {
  matchGames: BracketSeedMatchGameEntity[];
  teams: TournamentTeamEntity[];
}

export const TournamentMatchGamesList: FC<TournamentMatchGamesListProps> = ({
  matchGames,
  teams,
}) => {
  const { classes } = useStyles();

  const tournament = useSelector(currentTournamentSelector.tournament);

  if (!isArray(matchGames) || !matchGames.length) {
    return (
      <Box className={classes.placeholder}>
        <EmptyPlaceholder />
      </Box>
    );
  }

  return (
    <Box>
      {matchGames.map((matchGame) => (
        <Box key={matchGame.id} pb={1}>
          <TournamentMatchGameCard
            matchGame={matchGame}
            gameIcon={tournament.game?.icon}
            tournamentStatus={tournament.status}
            teams={teams}
          />
        </Box>
      ))}
    </Box>
  );
};
